import { applyMiddleware, compose, createStore } from 'redux';
import { appConfig } from '@services';
import thunk from 'redux-thunk';
//
import { reducers } from './reducers';

//
const middlewares = [applyMiddleware(thunk)];
if (appConfig.isDevelopment)
	middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export const store = createStore(reducers, compose(...middlewares));
